module.exports = __webpack_public_path__ + "img/combo_7.8575174f.png";